import React from 'react';
import './WhatWeDo.css';

const WhatWeDo = () => {
  const services = [
    {
      title: 'VR TRAINING SIMULATIONS',
      description: 'Hands-on practice in realistic virtual environments. Employees learn faster because they do, not just watch.',
      image: '/images/VR TRAINING SIMULATIONS.jpg'
    },
    {
      title: 'SAFETY & OPERATIONS TRAINING',
      description: 'Rehearse procedures, emergencies, and high-risk scenarios without real-world danger. Fewer mistakes. More confidence. Lower training costs.',
      image: '/images/SAFETY & OPERATIONS TRAINING.jpg'
    },
    {
      title: 'EDUCATION & INTERACTIVE EXPERIENCES',
      description: 'Immersive lessons for schools and enterprises. Complex concepts become clear, visual, and memorable — from science classes to professional skill building.',
      image: '/images/EDUCATION & INTERACTIVE EXPERIENCES.jpg'
    }
  ];

  return (
    <div id="what-we-do" className="container-fluid fh5co-network">
      <div className="container-fluid px-5">
        <div className="row">
          <div className="col-12">
            <div className="quote-box2 wow bounceInDown" data-wow-delay=".15s">
              <h2 style={{color: '#ff6600'}}>IMPROVE LEARNING THROUGH VR</h2>
            </div>
          </div>
        </div>
        <div className="row align-items-stretch">
          {services.map((service, index) => (
            <div key={index} className="col-md-4">
              <div 
                className={`card h-100 wow ${index === 0 ? 'bounceInLeft' : index === 1 ? 'bounceInUp' : 'bounceInRight'}`} 
                data-wow-delay={`${0.1 + index * 0.05}s`}
                style={{
                  borderRadius: 0,
                  position: 'relative',
                  overflow: 'hidden',
                  padding: 0,
                  backgroundImage: `url('${service.image}')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat'
                }}
              >
                <div className="card-body d-flex flex-column" style={{position: 'relative', zIndex: 1}}>
                  <h4 className="card-title" style={{color: '#fff'}}>{service.title}</h4>
                  <p className="card-text" style={{color: '#fff'}}>{service.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;

